import { render, staticRenderFns } from "./CellLink.vue?vue&type=template&id=2d5806ba&scoped=true&"
import script from "./CellLink.vue?vue&type=script&lang=js&"
export * from "./CellLink.vue?vue&type=script&lang=js&"
import style0 from "./CellLink.vue?vue&type=style&index=0&id=2d5806ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5806ba",
  null
  
)

export default component.exports